<template>
  <div class="pagination annuaire-pagination">
    <span class="pagination-nombre">Nombre de résultats : {{ items.count }}</span>
    <ul class="pagination-pages">
      <li
        v-if="items.previous"
        @click="changePage(1)"
        class="pagination_page_item"
        title="Première page"
      >
        &lt;&lt;
      </li>
      <li
        v-if="items.previous"
        @click="changePage(page - 1)"
        class="pagination_page_item"
        title="Page précédente"
      >
        &lt;
      </li>
      <li class="pagination_page_affichage">
        Page
        <input
          @change="validatePage($event.target.value)"
          :value="page"
        />
        sur {{ items.nb_pages }}
      </li>
      <li
        v-if="items.next"
        @click="changePage(page + 1)"
        class="pagination_page_item"
        title="Page suivante"
      >
        &gt;
      </li>
      <li
        v-if="items.next"
        @click="changePage(items.nb_pages)"
        class="pagination_page_item"
        title="Dernière page"
      >
        &gt;&gt;
      </li>
    </ul>
    <div class="error">{{ errors.page }}</div>
  </div>
</template>

<script>
export default {
  name: 'PaginationItem',

  props: {
    items: Object,
    page: Number
  },

  data () {
    return {
      errors: {
        page: null
      }
    }
  },

  beforeRouteUpdate (to, from, next) {
    this.errors.page = null
    next()
  },

  methods: {
    changePage (page) {
      this.errors.page = null
      this.$emit('changePage', page)
      window.scrollTo(0,0);
       if (this.items.next && this.items.results[0].title) {
        this.$router.replace({
          name: 'news',
          params: { loadMore: true },
          query: {
            page: this.page + 1,
            categorie: this.selectedTag,
            keywords: this.keywords
          }
        })
      }
      if (this.items.previous && this.items.results[0].title) {
        this.$router.replace({
          name: 'news',
          params: { loadMore: true },
          query: {
            page: this.page - 1,
            categorie: this.selectedTag,
            keywords: this.keywords
          }
        })
      }
    },

    validatePage (page) {
      this.errors.page = null
      page = Number(page)
      if (Number.isInteger(page) && page >= 1 && page <= this.items.nb_pages) {
        this.$emit('changePage', page)
        if (this.items.results[0].title) {
        this.$router.replace({
          name: 'news',
          params: { loadMore: true },
          query: {
            page: page,
          }
        })
        }

      } else {
        this.errors.page = 'Veuillez entrer un nombre entier compris ' +
          `entre 1 et ${this.items.nb_pages}`
      }
    }
  }
}
</script>
